<template>
    <div class="dialogVerification" style="border-radius: 8px; display: flex">
      <el-dialog
        v-model="verificationDialog"
        width="37%"
        :close-on-click-modal="false"
        align-center
      >
        <template #header="{ close, titleId, titleClass }">
          <div
            style="
              display: flex;
              align-items: center;
              justify-content: space-between;
            "
          >
            <h4 :id="titleId" :class="titleClass" class="my-header">
              Verify OTP
            </h4>
            <img
              @click="close()"
              src="../../assets/close.svg"
              style="height: 20px; width: 20px; cursor: pointer"
            />
          </div>
        </template>
        <div
          style="
            display: flex;
            flex-direction: column;
            gap: 20px;
            align-items: center;
            justify-content: center;
            margin-top: 10px;
          "
        >
          <span class="verifyHeader">
            Enter the 4 digit OTP sent to your mobile number.</span
          >

          <div class="pinInputContainer" ref="pinContainer">
            <input
              v-for="n in otpProps.length"
              @input="(e) => handleOtpKey(e, n - 1)"
              type="text"
              :key="n"
              v-model="optArray[n - 1]"
              maxlength="1"
              class="pinInput"
            />
          </div>

          <p class="otp_not_received">Didn't receive an OTP?</p>
          <div style="display: flex; align-items: center; gap: 10px">
            <p
              style="text-decoration: underline"
              :class="timer > 0 ? 'otp_send_disabled' : 'otp_send'"
              @click="resendOtp()"
              v-if="timer === 0"
            >
              Resend OTP
            </p>
            <span v-if="timer > 0" style="color: #777; text-decoration: none"
              >Time Remaining: {{ timer }} <span v-if="timer > 1">secs</span>
              <span v-else>sec</span></span
            >
          </div>
        </div>
        <div
          class="veri_button"
          style="display: flex; align-items: center; justify-content: center"
        >
          <el-button 
            :loading="loading"
            :disabled="handleButtonDisabled()"
            :class="[handleVerifyStyles(), calculatorData.isTata ? '' : 'moreDetailsButton2']"
            style="
              display: flex;
              align-items: center;
              justify-content: center;
              text-transform: none;
            "
            @click="verifyOtp"
          >
            <p class="verify_received"></p>
            Verify
          </el-button>
        </div>
      </el-dialog>
    </div>
    
</template>


<script setup>
import { ref, reactive, computed } from "vue";
import { solarCalculatorStore } from "../../../store/solarCalculator";
import API from "../../../../services/api";
import { SOLAR_CALCULATOR_ORG_ID_FOR_TATA } from "../../../../constants";


const props = defineProps({
  verificationDialog: Boolean,
});

const emit = defineEmits(['update:verificationDialog', 'showContent', 'isCalculateRoi', 'generate'])

const otpProps = reactive({
  length: 4,
});
const optArray = ref([]);
const timer = ref(0);
const pinContainer = ref();
const loading = ref(false);

const store = solarCalculatorStore();
const calculatorData = store.CALCULATOR_DATA_STATE;

const verificationDialog = computed({
  get: () => props.verificationDialog,
  set: (value) => emit('update:verificationDialog', value)
})

const handleOtpKey = (e, i) => {
  const children = pinContainer.value.children;
  const keyPressed = e.data;

  if (keyPressed === " ") {
    optArray.value[i] = null;
  }

  if (e.inputType === "deleteContentBackward") {
    if (optArray.value[i] === null || optArray.value[i] === "") {
      optArray.value.length -= 1;
      if (i > 0) {
        children[i - 1].focus();
      }
    }
  }
  const matched = keyPressed.match(/^[0-9]$/);
  if (!matched) {
    optArray.value[i] = null;
    return;
  } else {
    optArray.value[i] = keyPressed;
    if (i < otpProps.length - 1) {
      children[i + 1].focus();
    }
  }
};

const setTimerValue = () => {
  timer.value = 60;
  const interval = setInterval(() => {
    if (timer.value > 0) {
      timer.value--;
    } else {
      clearInterval(interval);
    }
  }, 1000);
};


const resendOtp = async () => {
  if (timer.value > 0) {
    return;
  }

  loading.value = true;
  const send_otp_data = {
    phone: `91${calculatorData.mobile_no}`,
    org:263,
    domain: calculatorData.orgName,
  };

  try {
    await API.SOLARCALCULATOR.SEND_OTP(send_otp_data);
    ElMessage({
      showClose: true,
      message: "OTP sent successfully",
      type: "success",
      center: true,
    });
    setTimerValue();

    loading.value = false;
  } catch (err) {
    ElMessage({
      showClose: true,
      message: "Unable to send OTP.",
      type: "error",
      center: true,
    });
    loading.value = false;
  }
};

const handleButtonDisabled = () => {
  const condition = optArray.value.some((item) => item === null);

  if (condition === false && optArray.value.length === 4) {
    return false;
  } else {
    return true;
  }
};

const handleVerifyStyles = () => {
  const condition = optArray.value.some((item) => item === null);

  if (condition === false && optArray.value.length === 4) {
    return "moreDetailsButton";
  } else {
    return "button_disabled";
  }
};

const isMobile = () => {
  return window.innerWidth < 740;
};

const verifyOtp = async () => {
  const optEntered = optArray.value.join("");
  const requestBody = {
    phone: `91${calculatorData.mobile_no}`,
    otp: Number(optEntered),
    domain: calculatorData.orgName,
  };

  try {
    loading.value = true;
    const otpResponse = await API.SOLARCALCULATOR.VERIFY_OTP(requestBody);
    if (calculatorData.isTata) {
      const nameParts = calculatorData.name.trim().split(' ');
      const firstName = nameParts[0] || '';
      const lastName = nameParts.length > 1 ? nameParts.slice(1).join(' ') : firstName;
      const attachments = [];
      if (calculatorData.upload_files && Object.keys(calculatorData.upload_files).length > 0) {
        Object.keys(calculatorData.upload_files).forEach(key => {
          const file = calculatorData.upload_files[key];
          attachments.push({
            fileName: file.file_info,
            base64Data: file.url || ''
          });
        });
      }

      const tataRequestBody = {
        last_name: lastName,
        first_name: firstName,
        email: calculatorData.email,
        phone: calculatorData.mobile_no,
        pin_code: calculatorData.pin_code,
        average_monthly_electricity_bill: calculatorData.monthly_bill,
        category: calculatorData.account_type,
        application_segment: "Roof Top",
        sanctioned_load: calculatorData.sanction_load,
        rooftop_area_available: calculatorData.rooftop_area,
        unit: "kW",
        attachments: attachments,
        org: SOLAR_CALCULATOR_ORG_ID_FOR_TATA,
        domain: calculatorData.orgName,
      };

      try {
        const response = await API.SOLARCALCULATOR.CREATE_TATA_LEAD(tataRequestBody);
        emit('showContent', true);
      } catch (error) {
        const errorMessage = error.response?.data?.error || 'Failed to create Tata user';
        ElMessage({
          showClose: true,
          message: errorMessage,
          type: 'error',
          center: true
        });
      }
    } else {
      emit('showContent', true);
    }
    if (isMobile()) {
      store.UPDATE_CALCULATOR_DATA(false, "showFormPage");
    }
    emit('isCalculateRoi', false);
    emit('generate', true);
    store.UPDATE_CALCULATOR_DATA(true, "isAllDetailsFilled");
    verificationDialog.value = false;
    ElMessage({
      showClose: true,
      message: "OTP verified successfully",
      type: "success",
      center: true
    });
    loading.value = false;
  } catch (err) {
    ElMessage({
      showClose: true,
      message: "OTP is incorrect",
      type: "error",
      center: true,
    });
    loading.value = false;
  }
};

</script>
 

<style scoped>
.main_outage_form {
  display: flex;
  gap: 10px;
}

.wrapper_outage_form {
  margin-top: 10px;
  display: flex;
  align-items: center;
  padding: 5px;
  box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.15);
  border-radius: 8px;
  flex: 1;
  height: 10vh;
}

.powerCard {
  flex: 1;
  display: flex;
  height: 64px;
  padding: 10px 16px;
  align-items: center;
  justify-content: center;
  gap: 10px;
  border-radius: 8px;
  background: var(--White, #fff);
  box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.15);
}

.blueButton {
  padding-top: 10px;
  padding-bottom: 10px;
  background-color: #006eaf;
  border: none;
  outline: none;
  color: var(--grey-grey-100, var(--White, #fff));
  font-family: Arial;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  cursor: pointer;
}

.right {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-left: 10px;
}

.blueContainer {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #006eaf;
  margin-top: 10px;
  border-radius: 8px;
}

.dialogCustom {
  position: relative;
  height: 100%;
}

.dialogVerification >>> .el-dialog__header {
  background-color: #e8edf2;
  margin-right: 0;
  border-radius: 8px 8px 0px 0px;
}

.dialogCustom >>> .el-dialog__header {
  background-color: #e8edf2;
  margin-right: 0;
  border-radius: 10px 10px 0px 0px;
  padding: 0;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 15px;
  padding-bottom: 15px;
  width: 100%;
  position: sticky;
  top: 0;
  z-index: 999;
}

.dialogVerification >>> .el-dialog__header {
  background-color: #e8edf2;
  margin-right: 0;
  border-radius: 10px 10px 0px 0px;
  padding: 0;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 15px;
  padding-bottom: 15px;

  position: sticky;
}

.slider_inner_button {
  background-color: black;
  color: white;
  border: none;
  margin-bottom: 1px;
  cursor: pointer;
}

.slider_inner_disable_button {
  background-color: #ccc;
  color: white;
  border: none;
  margin-bottom: 2px;
  cursor: not-allowed;
}

.dialogCustom >>> .el-checkbox__inner {
  z-index: 0;
}

.dialogCustom >>> .el-checkbox__inner {
  z-index: 0;
}

.dialogCustom >>> .el-checkbox__input {
  background-color: yellow;
}

.dialogVerification >>> .el-dialog__body {
  padding: 16px;
  color: black;
}

.dialogCustom >>> .el-dialog__body {
  padding: 0px;
  color: black;
}

.moreDetailsButton {
  width: 100%;
  border: none;
  outline: none;
  background-color: var(--Primary-Tata, #006eaf);
  border-radius: 8px;
  cursor: pointer;
  font-weight: 700;
  font-size: 20px;
  color: white;
  padding: 16px;
  z-index: 999;
  height: 56px;
}

.moreDetailsButton2 {
  background-color: #409EFF;
}

.button_disabled {
  width: 100%;
  height: 100%;
  border: none;
  padding: 16px;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  border-radius: 8px;
  cursor: not-allowed;
  background-color: #C6E2FF;
  outline: none;
  color: #fff;
}

.dialogVerification >>> .el-button.is-disabled:hover {
  background-color: #C6E2FF;
  color: #fff;
}

.loading_popup >>> .el-dialog__headerbtn {
  display: none;
}

.loading_popup >>> .el-dialog__header {
  display: none;
}

.loading_popup :deep() .el-dialog {
  padding: 0px;
  border-radius: 8px;
}

.productTypes {
  margin-top: 10px;
}

.cards {
  margin-top: 10px;
  height: 20vh;
  /* background-color: #006eaf; */
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
}

.cardWrapper {
  color: black;
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;
  justify-content: center;
}

.input_containers {
  margin-top: 10px;
}

.input_containers :deep() .el-input__inner {
  color: black;
  font-size: 16px;
}
.logo_card {
  margin-top: 10px;
  border-radius: 8px;
  padding: 10px;
  border: 1px solid #cccccc;
}
.input_fields {
  margin-top: 5px;
  color: black;
}

.input_error_fields {
  margin-top: 5px;
  color: black;
}

.input_fields >>> .el-input.is-disabled .el-input__inner {
  color: #2c2727; /* Change this color to your desired text color */
}

.input_error_fields >>> .el-input.is-disabled .el-input__inner {
  color: #2c2727; /* Change this color to your desired text color */
}

.input_capacity {
  display: flex;
  height: 48px;
  padding: 10px 16px;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  border: none;
  background: var(--White, #fff);
  border-radius: 8px;
  border: 1px solid var(--Grey-CCC, #ccc);
  box-shadow: 0 0 0 1px var(--el-input-border-color, var(--el-border-color))
    inset;
  margin-top: 5px;
}

.input_capacity >>> .el-input-group__append {
  box-shadow: none;
  background-color: white;
}
.input_fields >>> .el-input__wrapper {
  display: flex;
  height: 48px;
  padding: 10px 16px;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  border-radius: 8px;
  border: 1px solid var(--Grey-CCC, #ccc);
  background: var(--White, #fff);
}

.input_error_fields >>> .el-input__wrapper {
  display: flex;
  height: 48px;
  padding: 10px 16px;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  border-radius: 8px;
  border: 1px solid var(--Grey-CCC, red);
  background: var(--White, #fff);
}

.is_focus {
  outline: none;
  border: none;
}

.mainPowerContainer {
  margin-top: 10px;
  border: 1px solid var(--CCC, #ccc);
  padding: 10px;
  border-radius: 5px;
}

.pinInputContainer {
  display: flex;
  gap: 20px;
}

.pinInput {
  width: 50px;
  text-align: center;
  border-radius: 2px;
  border: none;
  border-bottom: 1px solid grey;
  outline: none;
  font-size: 18px;
  padding: 5px;
}

.PDcard {
  padding: 16px 10px;
  border-radius: 4px;
  background-color: #e8edf2;
  text-align: center;
  height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 120px;
  height: 120px;
  border: 1px dashed var(--999, #999);
  gap: 8px;
  cursor: pointer;
  align-self: center;
}

.productTypes >>> .el-radio__input.is-checked + .el-radio__label {
  color: black;
}

.productTypes >>> .el-radio__input.is-checked .el-radio__inner {
  border-color: #006eaf;
  background-color: white;
  border: 2px solid #006eaf;
}

.number_input >>> .el-input-number__decrease {
  border-radius: 50%;
  background-color: #0d0d0d;
  color: white;
  font-size: 14px;
  width: 30px;
  height: 30px;
}

.Verification {
  position: sticky;
  bottom: 0;
  background: var(--White, #fff);
  box-shadow: 4px 0px 10px 0px rgba(0, 0, 0, 0.25);
  width: 100%;
  padding: 10px;
}

.fixed-header {
  position: sticky;
  top: 0;
}

.veri_button {
  background: var(--White, #fff);
  width: 100%;
  padding-top: 30px;
  padding-left: 30px;
  padding-right: 30px;
  padding-bottom: 15px;
  display: flex;
  align-items: center;
}

.number_input >>> .el-input-number__increase {
  border-radius: 50%;
  background-color: #0d0d0d;
  color: white;
  height: 30px;
  width: 30px;
  font-size: 14px;
}

.time_input {
  border-radius: 4px;
  border: 1px solid var(--999, #999);
  background: var(--White, #fff);
  width: 60px;
  padding: 5px;
  display: flex;
  align-items: center;
  cursor: not-allowed;
}

.appliances_input {
  border-radius: 8px;
  border: 1px solid var(--CCC, #ccc);
  background: var(--White, #fff);
  width: 70px;
  padding: 5px;
  display: flex;
  align-items: center;
  height: 35px;
}

.time_button {
  cursor: pointer;
}

.appliances_time_button {
  height: 22px;
  width: 22px;
  border: none;
  border-radius: 50%;
  color: white;
  background-color: #006eaf;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.time_disabled_button {
  /* height: 22px;
  width: 22px;
  border-radius: 50%;
  border: none;
  color: white;
  background-color: #ccc;
  display: flex;
  align-items: center;
  justify-content: center; */
  cursor: not-allowed;
}

.appliances_time_disabled_button {
  cursor: not-allowed;
}

.time_input >>> input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.watt_appliances >>> input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.input_fields >>> input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.input_error_fields >>> input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.input_fields >>> input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.number_input >>> .el-input__inner {
  border: 1px;
  box-shadow: 0 0 0 1px var(--el-input-border-color, var(--el-border-color))
    inset;
}

.number_input >>> .el-input__wrapper {
  box-shadow: none;
}

.productTypes >>> .el-radio__inner::after {
  height: 6px;
  width: 5.5px;
  background-color: #006eaf;
  top: 50%;
  left: 50%;
}

.requiredClass {
  color: red;
}

.dropdownContainer {
  width: 100%;
}

.dropdownContainer >>> .el-select .el-input__wrapper {
  display: flex;
  height: 48px;
  width: 100%;
  padding: 10px 12px;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  border-radius: 8px;
  border: 1px solid var(--Grey-CCC, #ccc);
  background: var(--White, #fff);
}

.appliances_number_input :deep() .el-input-number__decrease {
  border-radius: 50%;
  background-color: #006eaf;
  color: #fff;
  height: 50%;
  top: 25%;
  width: 13%;
}

.appliances_number_input :deep() .el-input-number__increase {
  border-radius: 50%;
  background-color: #006eaf;
  color: #fff;
  height: 50%;
  top: 25%;
  width: 13%;
  right: 19%;
}

.appliances_number_input :deep() .el-input__wrapper {
  box-shadow: none;
}

.appliances_number_input :deep() .el-input__inner {
  height: 35px;
  box-shadow: 0 0 0 1px var(--el-input-border-color, var(--el-border-color))
    inset;
  border-radius: 8px;
  position: relative;
  left: -22%;
}

.watt_appliances :deep() .el-input__wrapper {
  width: 90px;
  border-radius: 8px;
  border: 1px solid var(--CCC, #ccc);
  background: var(--White, #fff);
  box-shadow: none;
}

.productTypes >>> .el-select .el-input__wrapper {
  display: flex;
  height: 48px;
  padding: 10px 12px;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  border-radius: 8px;
  border: 1px solid var(--Grey-CCC, #ccc);
  background: var(--White, #fff);
  margin-top: 10px;
}

.error_field {
  margin-top: 5px;
  color: red;
  font-size: 12px;
}

.dialogCustom >>> .el-dialog {
  height: 80vh;
  overflow: scroll;
  border-radius: 10px;
  position: relative;
}

.dialogVerification >>> .el-dialog {
  border-radius: 10px;
  padding: 0px;
}

.input_time {
  outline: none;
  border: none;
  width: 20px;
  cursor: not-allowed;
}

.appliances_input_value {
  outline: none;
  border: none;
  width: 100%;
}

.appliances_watt_value {
  width: 80px;
  border-radius: 8px;
  border: 1px solid var(--Grey-CCC, #ccc);
  background: var(--White, #fff);
  height: 35px;
  padding: 5px;
  outline: none;
}
.time_container {
  margin-top: 10px;
  padding: 10px;
  border-radius: 8px;
  border: 1px solid var(--Grey-CCC, #ccc);
  background: var(--White, #fff);
}

.input_number {
  display: flex;
  align-items: center;
  gap: 10px;
}

.check_box {
  margin-top: 10px;
  padding-left: 20px;
  margin-bottom: 10px;
}

.check_box >>> .el-checkbox__input.is-checked + .el-checkbox__label {
  color: black;
}

.dialog_title {
  color: var(--222, #222);
  font-family: Arial;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.error_dialog_title {
  color: red;
  font-family: Arial;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.unit_text {
  color: var(--Grey-777, var(--777, #777));
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.img_container {
  position: relative;
  box-shadow: 0 0 0 1px var(--el-input-border-color, var(--el-border-color))
    inset;
  margin-top: 10px;
  border-radius: 8px;
  display: flex;
  width: 120px;
  height: 120px;
  padding: 12px;
  flex-direction: column;
  gap: 10px;
  justify-content: center;
  align-items: center;
  background: var(--Background, #e8edf2);
}

.el-message.is-closable .el-message__content {
  z-index: 9999;
}

.delete-button {
  display: none;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.verifyHeader {
  color: #000;
  text-align: center;
  font-family: Arial;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.info_note {
  color: var(--Grey-777, var(--777, #777));
  font-family: Arial;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-top: 10px;
}

.dialogCustom >>> .el-dialog {
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* Internet Explorer */
  border-radius: 8px;
}

.upload-demo >>> .el-upload-dragger {
  display: flex;
  width: 120px;
  height: 120px;
  padding: 12px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 8px;
  border: 1px dashed var(--Grey-777, #777);
  background: var(--White, #fff);
}

.capacity_input {
  border: none;
  outline: none;
  background-color: white;
  color: black;
  font-size: 16px;
}

.capacity_input:hover {
  cursor: no-drop;
}

.input_capacity:hover {
  cursor: no-drop;
}

.otp_not_received {
  color: var(--777, #777);
  text-align: center;
  font-family: Arial;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.verify_received {
  color: var(--White, #fff);
  font-family: Arial;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.file_input {
  height: 100%;
  width: 100%;
  display: none;
}

.otp_send {
  color: #000;
  text-align: center;
  font-family: Arial;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-decoration-line: underline;
  cursor: pointer;
}

.otp_send_disabled {
  color: #ccc;
  text-align: center;
  font-family: Arial;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-decoration-line: underline;
  cursor: not-allowed;
}

.input_field_error >>> .el-input__wrapper {
  display: flex;
  height: 48px;
  padding: 10px 16px;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  border-radius: 8px;
  border: 1px solid var(--Grey-CCC, #ef1212);
  background: var(--White, #fff);
}

.file_upload_card {
  display: flex;
  width: 120px;
  height: 120px;
  padding: 12px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 8px;
  border: 1px dashed var(--Grey-777, #777);
  background: var(--White, #fff);
  margin-top: 10px;
  cursor: pointer;
}

.custom-checkbox >>> .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #006eaf;
  border: #006eaf;
}

.custom-checkbox :deep() .el-checkbox__inner::after {
  left: 5px;
  top: 2px;
}

.details_card {
  padding: 10px;
  margin-top: 10px;
  background-color: var(--777, #edf1f5);
  border-radius: 8px;
  box-shadow: 0 0 0 1px var(--el-input-border-color, var(--el-border-color))
    inset;
}

.contact_details {
  font-weight: bold;
  font-size: 14px;
  line-height: 18px;
  color: #006eaf;
}

.contact_info {
  font-size: 14px;
  line-height: 18px;
  font-weight: bold;
}

.contact_wrapper {
  display: flex;
  align-items: center;
  padding: 10px;
  gap: 10px;
}

.note {
  color: var(--Grey-777, var(--777, #777));
  font-family: Arial;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.dialogCustom >>> .el-dialog__headerbtn {
  display: none;
}

.dialogVerification >>> .el-dialog__headerbtn {
  display: none;
}

.dialogCustom >>> .el-dialog::-webkit-scrollbar {
  display: none; /* Webkit (Chrome, Safari, etc.) */
}
.input_fields >>> .el-input-number__decrease {
  display: none;
}

.input_error_fields >>> .el-input-number__decrease {
  display: none;
}

.appliances_details_container {
  display: flex;
  align-items: center;
  justify-content: end;
  gap: 13px;
}

.main_appliances_container {
  border-radius: 8px;
  border: 1px solid #ccc;
  background: #fff;
  padding: 16px;
  display: flex;
  gap: 10px;
  flex-direction: column;
  margin-top: 15px;
}

.appliances_title {
  margin-top: 12px;
  margin-bottom: 12px;
  color: var(--777, #777);
  font-family: Arial;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.appliances_add_button {
  display: flex;
  align-items: center;
  justify-content: end;
}

.appliances_button {
  border: none;
  background-color: white;
  color: #184d93;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 26px; /* 162.5% */
  cursor: pointer;
}

.appliances_details {
  color: var(--777, #777);
  font-family: Arial;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.hrClass {
  border-top: 2px solid #cccccc;
}

.appliances_values {
  color: #000;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.appliances_names {
  color: var(--Black, var(--222, #222));
  font-family: Arial;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.appliances_table {
  display: flex;
  padding: 0px 16px;
  flex-direction: column;
  align-items: center;
  align-self: stretch;
  border-radius: 8px;
  border: 1px solid var(--CCC, #ccc);
}

.appliances_input >>> input[type="number"]::-webkit-inner-spin-button,
.appliances_input input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
  color: red;
}

.input_time >>> input[type="number"]::-webkit-inner-spin-button,
.input_time input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
  color: red;
}

.my-header {
  color: #000;
  font-family: Arial;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.edit_data {
  margin-left: 90%;
  display: flex;
  align-items: center;
  gap: 10px;
}

.edit_data_actions {
  margin-left: 57%;
  display: flex;
  align-items: center;
  gap: 10px;
}

@media (max-width: 827px){
  .dialogCustom >>> .el-dialog {
    width: 90%;
    -ms-overflow-style: none;
  }
}

@media (max-width: 1180px){
  .dialogCustom >>> .el-dialog {
    width: 90%;
    -ms-overflow-style: none;
  }

  .loading_popup :deep() .el-dialog {
    padding: 0px;
    border-radius: 8px;
    width: 90%;
  }
  .dialogVerification >>> .el-dialog {
    width: 90%;
  }

  .main_appliances_container {
    padding: 8px;
  }

  .hours_card {
    flex-direction: column;
  }

  .time_container {
    width: 100%;
  }

  .right {
    margin-left: 20px;
  }
}

@media (max-width: 740px) {
  .time_container {
    width: 100%;
  }
  .hours_card {
    flex-direction: column;
  }
}
.collaps-content{
  display:flex;
  flex-direction: row;
  padding-top:16px;
  width: 100%;

}

.collaps-content-label{
  flex:0.5;
}
.collaps-content-value{
  flex:0.5;
  display: flex;
  justify-content: flex-end;
}
.collaps-content-name{
  flex:0.5;
  display: flex;
}
.collapse_container>>>.el-collapse-item__content{
  padding-bottom:0px

}
.btn_container{
  display: flex;
  justify-content: flex-end;
}
</style>